// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subContent {
  padding: 20px 10px;
}

.appLandingPage {
  background-image: var(--landing-bg-img);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 118vh;
  overflow-y: scroll;
  scrollbar-width: none;
  margin-bottom: 0px !important;
  position: relative;
}
.appLandingPage::-webkit-scrollbar {
  display: none;
}
.appLandingPage .appInnerBlock {
  z-index: 99;
  position: relative;
  display: flex;
  justify-content: center;
}

.appLandingPage::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(180, 176, 176, 0.3019607843);
  pointer-events: none;
}

.cardApp {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: white;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid rgba(19, 24, 52, 0.5294117647);
}
.cardApp:hover {
  transform: translateY(-5px);
  box-shadow: 0px 6px 6px 6px rgba(0, 0, 0, 0.168627451);
}
.cardApp h3 {
  margin: 0;
}
.cardApp p {
  font-size: 0.9em;
  margin-top: 5px;
}

.icon-container {
  font-size: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  /* background-color: rgba(255, 255, 255, 0.15); */
}

.appCardWrapper {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  overflow: hidden;
  padding-bottom: 7px;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
}
.appCardWrapper:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.18);
}

.appCardTopBorder {
  height: 6px;
  width: 100%;
  border-radius: 12px 12px 0 0;
}

.appCardContent {
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.appCardTitle {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
}

.appCardDesc {
  font-size: 13px;
  color: #4b5563;
  margin-top: 4px;
  max-width: 90%;
}

.appCardIcon {
  min-width: 90px;
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.appCardIcon img {
  width: 78px;
  height: 78px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.appCardWrapper:hover .appCardIcon img {
  transform: scale(1.12) translateY(-4px);
}`, "",{"version":3,"sources":["webpack://./src/Pages/customer_app_css/AppLandingPage.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAGA;EACE,uCAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;AAAF;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AADJ;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6CAAA;EACA,oBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,qDAAA;EACA,kBAAA;EACA,eAAA;EACA,gDAAA;AAFF;AAIE;EACE,2BAAA;EACA,sDAAA;AAFJ;AAKE;EACE,SAAA;AAHJ;AAME;EACE,gBAAA;EACA,eAAA;AAJJ;;AAQA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iDAAA;AALF;;AASA;EACE,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,eAAA;EACA,uDAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;UAAA,0BAAA;AANF;AAQE;EACE,2BAAA;EACA,2CAAA;AANJ;;AAUA;EACE,WAAA;EACA,WAAA;EACA,4BAAA;AAPF;;AAUA;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAPF;;AAUA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;AAPF;;AAUA;EACE,uCAAA;AAPF","sourcesContent":[".subContent {\n  padding: 20px 10px;\n}\n\n\n.appLandingPage {\n  background-image: var(--landing-bg-img);\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  min-height: 118vh;         \n  overflow-y: scroll;        \n  scrollbar-width: none;   \n  margin-bottom: 0px !important;\n  position: relative;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  .appInnerBlock {\n    z-index: 99;\n    position: relative;\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.appLandingPage::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #b4b0b04d; \n  pointer-events: none;  \n}\n\n.cardApp {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: white;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  border-radius: 8px;\n  cursor: pointer;\n  border: 1px solid #13183487;\n\n  &:hover {\n    transform: translateY(-5px);\n    box-shadow: 0px 6px 6px 6px #0000002b;\n  }\n\n  h3 {\n    margin: 0;\n  }\n\n  p {\n    font-size: 0.9em;\n    margin-top: 5px;\n  }\n}\n\n.icon-container {\n  font-size: 2em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  /* background-color: rgba(255, 255, 255, 0.15); */\n}\n\n\n.appCardWrapper {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n  overflow: hidden;\n  padding-bottom: 7px;    \n  backdrop-filter: blur(8px);\n\n  &:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.18);\n  }\n}\n\n.appCardTopBorder {\n  height: 6px;\n  width: 100%;\n  border-radius: 12px 12px 0 0;\n}\n\n.appCardContent {\n  padding: 14px 16px;      \n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n}\n\n.appCardTitle {\n  font-size: 18px;       \n  font-weight: 700;\n  color: #1f2937;\n}\n\n.appCardDesc {\n  font-size: 13px;         \n  color: #4b5563;\n  margin-top: 4px;    \n  max-width: 90%;\n}\n\n.appCardIcon {\n  min-width: 90px;       \n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.appCardIcon img {\n  width: 78px;            \n  height: 78px;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n}\n\n.appCardWrapper:hover .appCardIcon img {\n  transform: scale(1.12) translateY(-4px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
